export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        coaches: action.coaches,
      };
    case 'UPDATE':
      return {
        ...state,
        coaches: state.coaches.map(
          (item) => (item.id === action.coach.id ? action.coach : item),
        ),
      };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
